import {Model} from "./";
import {Api} from "../api";

class ElementModel extends Model {

    constructor() {
        super(new Api("/element"));
    }

    getCatalog(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/list/catalog');
        this.q.read(data, thenFunction, errorFunction);
    }

    getBrands(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/list/brand');
        this.q.read(data, thenFunction, errorFunction);
    }

    getElement(code, clientId, thenFunction, errorFunction) {
        this.q.setDopUrl('/detail/' + code);
        this.q.read({json: {clientId: clientId}}, thenFunction, errorFunction);
    }

    search(q,clientId,thenFunction, errorFunction){
        this.q.setDopUrl('/search-catalog');
        this.q.read({q: q,clientId:clientId}, thenFunction, errorFunction);
    }

    searchLimit(q,clientId,thenFunction, errorFunction){
        this.q.setDopUrl('/search-catalog');
        this.q.read({q: q,count2:100, clientId:clientId}, thenFunction, errorFunction);
    }
    searchByCategory(q,clientId,thenFunction, errorFunction){
        this.q.setDopUrl('/search-catalog-by-category');
        this.q.read({q: q, clientId:clientId}, thenFunction, errorFunction);
    }

    searchCode(q,thenFunction, errorFunction){
        this.q.setDopUrl('/search-catalog-code');
        this.q.read({q: q}, thenFunction, errorFunction);
    }
    searchCodeLimit(q,count,clientId,thenFunction, errorFunction){
        this.q.setDopUrl('/search-catalog-code');
        this.q.read({q: q,count:count,clientId:clientId}, thenFunction, errorFunction);
    }

    getMessages(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/list/news');
        this.q.read(data, thenFunction, errorFunction);
    }
    getAllCatalogList(data, thenFunction, errorFunction) {
        this.q.setDopUrl('/all');
        this.q.read(data, thenFunction, errorFunction);
    }

}

export default new ElementModel();